import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import * as React from "react";
import {useEffect, useState} from "react";
import {Box, Card, CardContent, Grid, Typography} from "@mui/material";
import {useETollChargesRepository} from "../../../api/repositories/ETollChargesRepository";
import ETollReportDetailTable from "../tables/ETollReportDetailTable";

const ETollReportDetail = () => {
    const {t} = useTranslation('finance', {keyPrefix: 'etoll'});

    const {getChargesByReport} = useETollChargesRepository();

    let {id} = useParams();

    const [data, setData] = useState<any>([]);
    const [totalElements, setTotalElements] = useState<any>(0);

    const [updating, setUpdating] = useState(false);

    useEffect(() => {
        getChargesByReport(id!, 0, 100000, null, null)
            .then(response => {
                let result = response.result;
                setData(result.content);
                setTotalElements(result["total-amount"]);
            });
    }, []);

    useEffect(() => {
        if (updating) {
            getChargesByReport(id!, 0, 100000, null, null)
                .then(response => {
                    let result = response.result;
                    setData(result.content);
                    setTotalElements(result["total-amount"]);
                    setUpdating(false);
                });
        }
    }, [updating])


    return (
        <Card variant="outlined" sx={{margin: '15px'}}>
            <CardContent>
                <Grid container direction={'column'} rowGap={2}>
                    <Grid item>
                        <Box style={{display: 'flex', alignItems: 'center', gap: '1ch'}}>
                            <Typography variant={'body1'} fontWeight={'bold'}>
                                { data['0']?.reportName }
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item>
                        <ETollReportDetailTable data={data} totalElements={totalElements}/>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default ETollReportDetail;